import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
    '& .menu-item, & .header-phone-link': {
      textTransform: 'none !important',
    },
    '& .MuiButton-root:not(.topbar-signup-cta)': {
      textTransform: 'none !important',
    },
    '& .topbar-signup-cta': {
      borderRadius: '0 !important',
      minHeight: '48px',
      minWidth: '144px',
      padding: '12px 20px !important',
      fontSize: '16px !important',
      fontWeight: 400,
      fontFamily: 'Lato-Regular !important',
      textTransform: 'uppercase !important',
      letterSpacing: '-0.32px',
      lineHeight: '20px !important',
      backgroundColor: `${palette.primary.main} !important`,
      color: `${palette.text.highlight} !important`,
      border: `1px solid ${palette.text.blueBorder} !important`,
      boxShadow: 'none !important',
      '&:hover': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.text.blueBorder} !important`,
        opacity: 0.92,
      },
    },
  },

  '.group-parent-container': {
    '& .normal-text': {
      fontWeight: 400,
      fontFamily: 'Cormorant-Medium !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 88,
      background: `${palette.primary.main} !important`,
      backgroundColor: `${palette.primary.main} !important`,
      backgroundImage: 'none !important',
      backgroundSize: 'unset !important',
      borderBottom: 'none !important',
      maxHeight: 'none !important',
      marginBottom: '0 !important',
      overflow: 'hidden',
      '& > .section, & > section': {
        background: `${palette.primary.main} !important`,
        backgroundColor: `${palette.primary.main} !important`,
        padding: '80px 40px !important',
        maxWidth: 'none !important',
        margin: '0 !important',
        '@media(max-width: 1024px)': {
          padding: '64px 40px !important',
        },
        '@media(max-width: 600px)': {
          padding: '48px 20px !important',
        },
      },
      '& .section-header': {
        alignItems: 'center !important',
        textAlign: 'center !important',
        marginBottom: '32px !important',
      },
      '& .section-header__title-wrapper, & .section-header__subtitle-wrapper': {
        justifyContent: 'center !important',
        textAlign: 'center !important',
      },
      '& .hero-header-title': {
        fontFamily: 'Cormorant-Medium !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.72px !important',
        fontWeight: 400,
        color: `${palette.text.highlight} !important`,
        textAlign: 'center !important',
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Lato-Regular !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.54px !important',
        fontWeight: '700 !important',
        color: `${palette.text.highlight} !important`,
        textAlign: 'center !important',
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
      '& .header-container': {
        justifyContent: 'center !important',
        margin: '0 !important',
        '& > .MuiGrid-item': {
          flexGrow: '0 !important',
          maxWidth: 'none !important',
        },
      },
      '& .hero-link-button, & .hero-link-button.MuiButton-containedPrimary': {
        borderRadius: '0 !important',
        minHeight: '44px',
        minWidth: 'auto',
        width: 'auto !important',
        padding: '12px 20px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Lato-Regular !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-1.12px',
        lineHeight: '20px !important',
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.primary.brand} !important`,
        border: `1px solid ${palette.primary.brand} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.primary.brand} !important`,
          opacity: 0.92,
        },
      },
      '& .hero-home-button, & .hero-home-button.MuiButton-outlinedSecondary': {
        borderRadius: '0 !important',
        minHeight: '44px',
        minWidth: 'auto',
        width: 'auto !important',
        padding: '12px 20px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Lato-Regular !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-1.12px',
        lineHeight: '20px !important',
        backgroundColor: 'transparent !important',
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.background.border} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
          color: `${palette.text.highlight} !important`,
          borderColor: `${palette.background.border} !important`,
          opacity: 0.92,
        },
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '80px',
    },
    '& .home-hero-wrapper': {
      position: 'relative',
      overflow: 'hidden',
      width: '100%',
      '&::after': {
        content: '""',
        position: 'absolute',
        inset: 0,
        background: palette.background.heroGradient,
        zIndex: 1,
        pointerEvents: 'none',
      },
      /* Desktop: full-bleed background image with overlaid copy (Figma) */
      '@media(min-width: 960px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        justifyContent: 'flex-end',
        width: '100%',
        aspectRatio: '1920 / 624',
        minHeight: '624px',
        height: 'auto !important',
        maxHeight: 'none !important',
      },
      '& .hero-background': {
        backgroundColor: palette.background.fill,
        /* Desktop: full-bleed cover (overrides MFE contain + object-position: right) */
        '@media(min-width: 960px)': {
          position: 'absolute !important',
          top: 0,
          left: 0,
          width: '100% !important',
          height: '100% !important',
          maxWidth: 'none !important',
          objectFit: 'cover !important',
          objectPosition: 'center center',
          zIndex: 0,
        },
        '@media(max-width: 959px)': {
          position: 'absolute !important',
          top: 0,
          left: 0,
          width: '100% !important',
          height: '100% !important',
          maxWidth: 'none !important',
          objectFit: 'cover !important',
          objectPosition: 'center center !important',
          zIndex: 0,
        },
        '@media(min-width: 601px) and (max-width: 959px)': {
          objectPosition: 'center top !important',
        },
      },
      '& .hero-section': {
        flex: '1 1 auto',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        position: 'relative',
        zIndex: 2,
        maxHeight: 'none',
        width: '100% !important',
        maxWidth: 'none !important',
        margin: '0 auto',
        boxShadow: 'none',
        '@media(min-width: 960px)': {
          paddingBottom: '80px',
          minHeight: '0 !important',
          flex: '1 1 auto',
        },
        '& .MuiGrid-container > .MuiGrid-item': {
          '@media(min-width: 960px)': {
            minHeight: '0 !important',
          },
        },
        '& .section-alternate__content > .MuiGrid-container': {
          '@media(max-width: 600px)': {
            justifyContent: 'flex-start !important',
          },
          '@media(min-width: 601px) and (max-width: 959px)': {
            justifyContent: 'center !important',
          },
        },
        '& .section-alternate__content > .MuiGrid-container > .MuiGrid-item': {
          '@media(min-width: 600px)': {
            flexBasis: '100% !important',
            maxWidth: '100% !important',
          },
        },
        '& .section-alternate__content': {
          backgroundColor: 'transparent',
          width: '100% !important',
          maxWidth: '100% !important',
          '@media(min-width: 960px)': {
            padding: '0 80px !important',
          },
          '@media(max-width: 1200px) and (min-width: 960px)': {
            padding: '0 50px !important',
          },
          '@media(max-width: 959px)': {
            padding: '0 24px !important',
          },
        },
        '& .section-header': {
          width: '100%',
          textAlign: 'center',
          flexDirection: 'column',
          flexWrap: 'nowrap',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '100%',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
          marginTop: 0,
          '@media(max-width: 600px)': {
            textAlign: 'left',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            marginLeft: 0,
            marginRight: 'auto',
          },
          '@media(min-width: 601px) and (max-width: 959px)': {
            textAlign: 'center !important',
            justifyContent: 'center !important',
            alignItems: 'center !important',
          },
          '& .section-header__overline-wrapper': {
            '@media(max-width: 600px)': {
              justifyContent: 'flex-start !important',
            },
            '@media(min-width: 601px) and (max-width: 959px)': {
              justifyContent: 'center !important',
            },
            color: `${palette.text.highlight} !important`,
          },
          '& .section-header__title-wrapper': {
            justifyContent: 'center !important',
            '@media(max-width: 600px)': {
              marginLeft: 0,
              marginRight: 'auto',
              justifyContent: 'flex-start !important',
            },
          },
          '& .section-header__title.home-hero-title': {
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            '@media(max-width: 600px)': {
              textAlign: 'left !important',
              marginLeft: 0,
              marginRight: 'auto',
            },
          },
          '& .section-header__subtitle-wrapper': {
            maxWidth: '640px !important',
            flexBasis: '100% !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            marginTop: '16px !important',
            '@media(max-width: 600px)': {
              marginLeft: 0,
              marginRight: 'auto',
            },
          },
          '& .section-header__cta-wrapper': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            marginTop: '32px !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            '@media(max-width: 600px)': {
              marginLeft: '0 !important',
              marginRight: 'auto !important',
            },
          },
          '& .section-header__cta-container': {
            flexWrap: 'nowrap',
            justifyContent: 'center !important',
            '@media(max-width: 600px)': {
              justifyContent: 'flex-start !important',
            },
          },
          '& .section-header__cta-item-wrapper': {
            gap: '24px !important',
            justifyContent: 'center !important',
            '@media(max-width: 600px)': {
              justifyContent: 'flex-start !important',
            },
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '64px !important',
        fontFamily: 'Cormorant-Medium',
        fontWeight: 500,
        maxWidth: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        lineHeight: '72px !important',
        letterSpacing: '-3.2px',
        whiteSpace: 'pre-line',
        color: `${palette.text.highlight} !important`,
        '@media(max-width: 1280px) and (min-width: 960px)': {
          fontSize: '56px !important',
          lineHeight: '62px !important',
          letterSpacing: '-2.8px !important',
        },
        '@media(max-width: 959px)': {
          fontSize: '40px !important',
          lineHeight: '44px !important',
          letterSpacing: '-2px !important',
          '@media(max-width: 600px)': {
            textAlign: 'left !important',
            marginLeft: 0,
            marginRight: 'auto',
          },
          '@media(min-width: 601px)': {
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
        },
      },
      '& .home-hero-subtitle': {
        display: 'block !important',
        fontSize: '20px !important',
        lineHeight: '28px !important',
        fontFamily: 'Lato-Regular !important',
        fontWeight: 400,
        textAlign: 'center !important',
        color: `${palette.text.highlight} !important`,
        maxWidth: '640px',
        marginLeft: 'auto',
        marginRight: 'auto',
        '@media(max-width: 1280px) and (min-width: 601px)': {
          fontSize: '18px !important',
          lineHeight: '26px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '16px !important',
          lineHeight: '24px !important',
          textAlign: 'left !important',
          marginLeft: 0,
          marginRight: 'auto',
        },
      },
      '& .customSubtitleItems': {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '20px !important',
        fontFamily: 'Lato-Regular !important',
        fontWeight: 400,
        color: `${palette.text.highlight} !important`,
        margin: '0 12px',
        position: 'relative',
        '@media(max-width: 1280px) and (min-width: 601px)': {
          fontSize: '18px !important',
        },
        '&:not(:last-child)::after': {
          content: '""',
          position: 'absolute',
          right: '-12px',
          top: '50%',
          transform: 'translateY(-50%)',
          height: '16px',
          width: '1px',
          backgroundColor: `${palette.text.highlight}`,
          opacity: 0.4,
        },
        '@media(max-width: 600px)': {
          display: 'flex',
          width: '100%',
          margin: '6px 0',
          fontSize: '16px !important',
          '&::after': {
            display: 'none !important',
          },
        },
        '& .customIcon': {
          width: '20px',
          height: '20px',
          flexShrink: 0,
        },
      },
      '& .hero-link-button': {
        borderRadius: '0 !important',
        minHeight: '44px',
        minWidth: 'auto',
        padding: '12px 20px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Lato-Regular !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-1.12px',
        lineHeight: '20px !important',
        backgroundColor: `${palette.text.highlight} !important`,
        color: `${palette.primary.brand} !important`,
        border: `1px solid ${palette.primary.brand} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.primary.brand} !important`,
          opacity: 0.92,
        },
      },
      '& .login-button': {
        borderRadius: '0 !important',
        minHeight: '44px',
        minWidth: 'auto',
        padding: '12px 32px !important',
        fontSize: '16px !important',
        fontWeight: 500,
        fontFamily: 'Lato-Regular !important',
        textTransform: 'uppercase !important',
        letterSpacing: '-1.12px',
        lineHeight: '20px !important',
        backgroundColor: 'transparent !important',
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.background.border} !important`,
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
          color: `${palette.text.highlight} !important`,
          opacity: 0.92,
        },
      },
      /* Mobile + tablet: full-bleed image with bottom overlay */
      '@media(max-width: 959px)': {
        display: 'flex !important',
        flexDirection: 'column !important',
        justifyContent: 'flex-end',
        position: 'relative',
        minHeight: '640px',
        height: '640px',
        maxHeight: 'none !important',
        paddingTop: '0 !important',
        backgroundColor: 'transparent',
        overflow: 'hidden',
        '& .hero-section': {
          order: 2,
          position: 'relative !important',
          zIndex: 2,
          flex: '1 1 auto !important',
          display: 'flex !important',
          alignItems: 'flex-end !important',
          height: '100% !important',
          minHeight: 'auto !important',
          maxHeight: 'none !important',
          backgroundColor: 'transparent !important',
          paddingBottom: '63px !important',
        },
        '& .hero-section .section-alternate__content > .MuiGrid-container > .MuiGrid-item': {
          maxWidth: '100% !important',
          flexBasis: '100% !important',
        },
        '& .section-alternate__content': {
          padding: '0 24px !important',
          backgroundColor: 'transparent !important',
        },
        '@media(max-width: 600px)': {
          '& .section-header': {
            display: 'flex',
            justifyContent: 'flex-start !important',
            textAlign: 'left !important',
            marginLeft: '0 !important',
            marginRight: 'auto !important',
            maxWidth: '100% !important',
          },
          '& .section-header__overline-wrapper, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
            {
              justifyContent: 'flex-start !important',
              textAlign: 'left !important',
              marginLeft: '0 !important',
              marginRight: 'auto !important',
            },
          '& .section-header__cta-container': {
            justifyContent: 'flex-start !important',
          },
        },
      },
      /* Tablet: same overlay layout as mobile, centered copy, show top of image */
      '@media(min-width: 601px) and (max-width: 959px)': {
        minHeight: '780px',
        height: '780px',
        '& .hero-section': {
          alignItems: 'flex-end !important',
          justifyContent: 'center !important',
          paddingBottom: '63px !important',
          '& .section-alternate__content > .MuiGrid-container': {
            justifyContent: 'center !important',
          },
          '& .section-header': {
            textAlign: 'center !important',
            justifyContent: 'center !important',
            alignItems: 'center !important',
          },
          '& .section-header__title-wrapper': {
            justifyContent: 'center !important',
          },
        },
        '& .section-alternate__content': {
          padding: '0 40px !important',
        },
        '& .hero-section .section-header': {
          justifyContent: 'center !important',
          textAlign: 'center !important',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
          alignItems: 'center !important',
          '& .section-header__overline-wrapper': {
            justifyContent: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__title-wrapper': {
            justifyContent: 'center !important',
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
            maxWidth: '100% !important',
            flexBasis: '100% !important',
          },
          '& .section-header__title.home-hero-title': {
            textAlign: 'center !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__cta-wrapper': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
          '& .section-header__cta-container': {
            justifyContent: 'center !important',
          },
          '& .section-header__cta-item-wrapper': {
            justifyContent: 'center !important',
          },
        },
        '& .hero-section .home-hero-title': {
          textAlign: 'center !important',
          marginLeft: 'auto !important',
          marginRight: 'auto !important',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: '#FAFAFA',
      backgroundColor: '#FAFAFA',
      '& .definition-variant-2': {
        background: 'transparent',
      },
      '& .MuiPaper-root': {
        backgroundColor: 'transparent !important',
      },
      '& .benefits-wrapper': {
        maxWidth: '1280px',
        margin: '0 auto',
        width: '100%',
      },
      '& .section-header': {
        alignItems: 'center !important',
        marginBottom: '72px !important',
        '@media(max-width: 900px)': {
          marginBottom: '48px !important',
        },
      },
      '& .section-header__title-wrapper': {
        justifyContent: 'center !important',
      },
      '& .section-header__subtitle-wrapper': {
        display: 'none !important',
      },
      '& .section-header__title': {
        fontWeight: 500,
        whiteSpace: 'pre-line',
        fontFamily: 'Cormorant-Medium !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-0.96px !important',
        color: `${palette.text.content} !important`,
        textAlign: 'center !important',
        paddingBottom: '0 !important',
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
      '& .definition-benefits-grid': {
        display: 'grid !important',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr)) !important',
        gap: '32px !important',
        margin: '0 !important',
        width: '100% !important',
        '@media(max-width: 900px)': {
          gridTemplateColumns: '1fr !important',
          gap: '40px !important',
        },
        '& > .MuiGrid-item': {
          padding: '0 !important',
          display: 'flex',
          maxWidth: 'none !important',
          flexBasis: 'auto !important',
          width: 'auto !important',
        },
      },
      '& .definition-service-tile': {
        border: 'none !important',
        backgroundColor: 'transparent !important',
        padding: '0 !important',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
      },
      '& .definition-service-innertile': {
        border: 'none !important',
        borderRadius: '0 !important',
        backgroundColor: 'transparent !important',
        padding: '0 !important',
        margin: '0 !important',
        width: '100% !important',
        height: '100%',
        boxSizing: 'border-box',
        justifyContent: 'flex-start !important',
        alignItems: 'center !important',
        flexDirection: 'column !important',
        flexWrap: 'nowrap !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
          maxWidth: '100% !important',
          width: '100% !important',
          flexBasis: 'auto !important',
          flexGrow: '0 !important',
          flexShrink: '0 !important',
        },
      },
      '& .definition-service-innertile > .MuiGrid-item.customIcon': {
        marginBottom: '32px !important',
      },
      '& .definition-service-innertile > .MuiGrid-item.definition-service-description-wrapper': {
        marginTop: '16px !important',
      },
      '& .customIcon': {
        justifyContent: 'center !important',
        padding: '0 !important',
        margin: '0 !important',
        maxWidth: '100% !important',
        flexBasis: 'auto !important',
        '& .image, & img': {
          width: '72px !important',
          height: '72px !important',
          display: 'block',
        },
      },
      '& .definition-service-title': {
        fontWeight: 500,
        fontFamily: 'Cormorant-Medium !important',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        color: `${palette.text.secondary} !important`,
        textAlign: 'center !important',
        padding: '0 !important',
        margin: '0 !important',
        maxWidth: '100% !important',
        flexBasis: 'auto !important',
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          lineHeight: '30px !important',
        },
      },
      '& .definition-service-description-wrapper': {
        maxWidth: '100% !important',
        flexBasis: 'auto !important',
        padding: '0 !important',
        margin: '0 !important',
      },
      '& .definition-service-description': {
        margin: '0 !important',
        padding: '0 !important',
        fontFamily: 'Lato-Regular !important',
        fontSize: '16px !important',
        lineHeight: '22px !important',
        color: `${palette.text.secondary} !important`,
        textAlign: 'center !important',
        letterSpacing: '-0.64px !important',
      },
      '& #definition-section.definition-variant-2': {
        padding: '96px 80px !important',
        '@media(max-width: 1200px) and (min-width: 600px)': {
          padding: '64px 40px !important',
        },
        '@media(max-width: 600px)': {
          padding: '48px 20px !important',
        },
      },
      '& .section-alternate__content': {
        padding: '0 !important',
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label': {
        color: `${palette.text.highlight} !important`,
      },
      '& .section-header__title': {
        fontWeight: 400,
        fontFamily: 'Cormorant-Medium !important',
        fontSize: '56px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.96px !important',
        whiteSpace: 'pre-line',
        '@media(max-width: 1280px) and (min-width: 601px)': {
          fontSize: '48px !important',
          lineHeight: '54px !important',
          letterSpacing: '-1.44px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '36px !important',
          lineHeight: '42px !important',
          letterSpacing: '-1.08px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'Lato-Regular !important',
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.8px !important',
        color: `${palette.text.highlight} !important`,
        '@media(max-width: 1280px) and (min-width: 601px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        // Tablet & mobile (single-card carousel): hide the nav arrows — the dot
        // pager (and swipe) remain for navigation — and center the plan card.
        // The slide (.carousel-single-item) already centers via justify-content;
        // let the card item shrink to the card so that centering takes effect.
        '@media (max-width: 1024px)': {
          '& [aria-label="carousel-left-btn"], & [aria-label="carousel-right-btn"]': {
            display: 'none !important',
          },
          '& .subscription-plan-card-item': {
            width: 'auto !important',
            flexGrow: '0 !important',
            flexBasis: 'auto !important',
            marginLeft: 'auto !important',
            marginRight: 'auto !important',
          },
        },
        '@media (min-width: 1280px)': {
          '& .carousel-single-item.MuiGrid-container': {
            display: 'grid !important',
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr)) !important',
            justifyContent: 'unset !important',
            '& > .subscription-plan-card-item': {
              maxWidth: '100% !important',
              flexBasis: 'auto !important',
              width: 'auto !important',
            },
          },
        },
        // Align the "* Best For:" disclaimer to the bottom of every card so it
        // lines up across cards regardless of how many "What's Included" items
        // each plan has. The card body fills its (equal) height as a column and
        // the disclaimer row is pushed down with margin-top:auto.
        '& .planCard .customCardContent .fullHeight': {
          flexGrow: '1 !important',
          flexDirection: 'column !important',
          flexWrap: 'nowrap !important',
        },
        // The grid children default to flex-basis:100% (sized for a flex-row);
        // in this column that would make them fill the height. Reset to auto so
        // they size to content, then push the disclaimer row to the bottom.
        '& .planCard .customCardContent .fullHeight > .planCardDescription': {
          flexBasis: 'auto !important',
          flexGrow: '0 !important',
          flexShrink: '0 !important',
        },
        '& .planCard .customCardContent .fullHeight > .plan-card-disclaimer-row': {
          flexBasis: 'auto !important',
          flexGrow: '0 !important',
          flexShrink: '0 !important',
          marginTop: 'auto !important',
        },
        // Hybrid/dual-arch cards (variant 5) put the disclaimer row directly
        // under .customCardContent (no .fullHeight wrapper) — push it to the
        // bottom the same way so its disclaimer aligns with the other cards.
        '& .planCard .customCardContent > .plan-card-disclaimer-row': {
          flexBasis: 'auto !important',
          flexGrow: '0 !important',
          flexShrink: '0 !important',
          marginTop: 'auto !important',
        },
        '& .planCard': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          borderRadius: '4px !important',
          border: 'none !important',
          color: `${palette.text.content} !important`,
          '&:hover': {
            color: palette.text.content,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.tertiaryLight,
            },
          },
          '& .customGetStarted, & .MuiButton-containedPrimary.customGetStarted': {
            backgroundColor: 'transparent !important',
            color: `${palette.primary.main} !important`,
            border: `1px solid ${palette.primary.main} !important`,
            boxShadow: 'none !important',
            '& .MuiButton-label': {
              color: `${palette.primary.main} !important`,
            },
            '&:hover': {
              backgroundColor: `${palette.primary.brand} !important`,
              color: `${palette.text.highlight} !important`,
              opacity: 1,
              boxShadow: 'none !important',
              borderColor: `${palette.primary.brand} !important`,
              '& .MuiButton-label': {
                color: `${palette.text.highlight} !important`,
              },
            },
          },
          '& .customcardTitle': {
            fontWeight: 400,
            fontFamily: 'Cormorant-Medium !important',
            fontSize: '24px !important',
            lineHeight: '30px !important',
            letterSpacing: '-0.48px !important',
            color: `${palette.text.content} !important`,
          },
          // "* Best For:" disclaimer — hanging indent so wrapped lines align
          // under the text (not under the leading "*"). Excludes the activation
          // fee line (.customUpfrontWrapper) and the Annual Savings line (no
          // leading "*"; hanging indent was pushing it right of the asterisks).
          '& .plan-card-disclaimer-row .disclaimerContainer .MuiGrid-item:not(.customUpfrontWrapper) .bold:not(.annual-savings-disclaimer)': {
            display: 'inline-block',
            paddingLeft: '10px',
            textIndent: '-10px',
          },
          '& .annual-savings-label': {
            color: `${palette.primary.brand} !important`,
            marginLeft: '10px !important',
          },
          '& .price-value': {
            fontWeight: 400,
            fontSize: '36px !important',
            fontFamily: 'Lato-Regular !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.72px !important',
            color: `${palette.text.content} !important`,
            '@media screen and (max-width: 700px)': {
              fontSize: '36px !important',
              lineHeight: '40px !important',
              letterSpacing: '-0.72px !important',
            },
          },
          '& .price-frequency, & .display-frequency, & .customSubscriberName': {
            color: `${palette.text.tertiaryLight} !important`,
          },
          '& .MuiTypography-body2': {
            color: `${palette.text.content} !important`,
          },
          '& .customBenefitsContainer': {
            '& .bold': {
              fontWeight: 400,
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.content} !important`,
            },
            '& .cptCodes': {
              fontSize: '14px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.28px !important',
              fontWeight: 400,
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.content} !important`,
            },
          },
          '& .customUpfrontWrapper': {
            color: `${palette.text.tertiary} !important`,
            fontWeight: 400,
            fontFamily: 'Lato-Regular !important',
            lineHeight: '16px !important',
            letterSpacing: '-0.36px !important',
            fontStyle: 'normal',
          },
          // Figma footer stack: activation → divider → savings → plan disclosure
          '& .disclaimerContainer': {
            // Cancel MuiGrid spacing's negative side margins so the row and the
            // activation-fee divider stay within the card content.
            marginLeft: '0 !important',
            marginRight: '0 !important',
            width: '100% !important',
            // Flush-left, and drop MuiGrid's item padding so vertical gaps are set
            // explicitly below and match across card variants.
            '& > .MuiGrid-item': {
              paddingLeft: '0 !important',
              paddingTop: '0 !important',
              paddingBottom: '0 !important',
            },
            '& .customUpfrontWrapper': {
              paddingLeft: '0 !important',
              width: '100% !important',
              paddingBottom: '20px !important',
              marginBottom: '20px !important',
              borderBottom: `1px solid ${palette.background.border} !important`,
            },
            '& .disclaimerText': {
              fontSize: '12px !important',
              lineHeight: '16px !important',
              letterSpacing: '-0.32px !important',
              fontWeight: 400,
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.tertiary} !important`,
            },
            // Annual Savings: 14px, with a 12px gap before the "* Best For" line.
            // The separator that used to sit under this line was dropped: the
            // plan card now renders its own divider above the whole disclosure
            // block, so keeping this one drew two rules 17px apart.
            '& .annual-savings-disclaimer.bold': {
              display: 'block',
              fontSize: '14px !important',
              lineHeight: '18px !important',
              marginBottom: '12px !important',
            },
            '& .customUpfrontWrapper .bold': {
              fontSize: '12px !important',
              lineHeight: '16px !important',
            },
            // Default disclaimer body (activation amount, etc.) stays tertiary.
            '& .bold': {
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontWeight: 400,
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.tertiary} !important`,
              fontStyle: 'normal',
            },
            // "Annual Savings:" — brand teal
            '& .annual-savings-label': {
              color: `${palette.primary.brand} !important`,
              marginLeft: '0 !important',
            },
            // Savings value + plan disclosure — same grey as activation fee
            '& .annual-savings-value, & .annual-savings-disclaimer': {
              color: `${palette.text.tertiary} !important`,
            },
            '& .MuiGrid-item:not(.customUpfrontWrapper) .bold:not(.annual-savings-disclaimer)': {
              color: `${palette.text.tertiary} !important`,
              fontSize: '12px !important',
              lineHeight: '16px !important',
            },
            '& .MuiTypography-body2': {
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.tertiary} !important`,
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
          '& .carousel-container': {
            maxWidth: '100% !important',
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: 0,
            paddingRight: 0,
            boxSizing: 'border-box',
          },
          '& .react-multi-carousel-item > div': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
          '& .carousel-single-item.MuiGrid-container': {
            width: '100%',
            marginLeft: 0,
            marginRight: 0,
            maxWidth: '100%',
          },
          '& .subscription-plan-card-item': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
          '& .planCard': {
            maxWidth: '100% !important',
            width: '100%',
            boxSizing: 'border-box',
          },
        },
        '& .bold': {
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          color: `${palette.text.tertiaryLight} !important`,
          fontFamily: 'Cormorant-Medium !important',
          '@media screen and (max-width: 700px)': {
            fontSize: '16px !important',
            lineHeight: '20px !important',
          },
        },
        '& .summary-text': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.8px !important',
          fontFamily: 'Lato-Regular !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .summary-subtext': {
          fontWeight: 400,
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.8px !important',
          color: `${palette.text.highlight} !important`,
        },
        '& .savings-summary-link': {
          color: `${palette.text.highlight} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: `${palette.background.main} !important`,
      backgroundColor: `${palette.background.main} !important`,
      borderTop: 'none !important',
      '& .section': {
        padding: '96px 80px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          padding: '64px 40px !important',
        },
        '@media(max-width: 600px)': {
          padding: '48px 20px !important',
        },
      },
      '& .howitworks-wrapper': {
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '0 !important',
        width: '100%',
      },
      '& .howitworks-grid': {
        display: 'grid !important',
        gridTemplateColumns: '1fr 1fr',
        gap: '120px !important',
        margin: '0 !important',
        width: '100% !important',
        alignItems: 'center',
        '@media(max-width: 900px)': {
          gridTemplateColumns: '1fr',
          gap: '40px !important',
        },
        '& > .MuiGrid-item': {
          padding: '0 !important',
          maxWidth: 'none !important',
          flexBasis: 'auto !important',
          width: 'auto !important',
        },
        '& > .cover-image-wrapper.MuiGrid-item': {
          width: '100% !important',
          minWidth: '0 !important',
        },
      },
      '& .howitworks-wrapper-left': {
        padding: '0 !important',
        '& > .MuiGrid-container': {
          margin: '0 !important',
          width: '100%',
          '& > .MuiGrid-item': {
            padding: '0 !important',
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
          },
        },
      },
      '& .howitworks-content-grid': {
        margin: '0 !important',
        width: '100% !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
      },
      '& .howitworks-title': {
        marginBottom: '64px !important',
        '& .section-header': {
          alignItems: 'flex-start !important',
          marginBottom: '0 !important',
        },
        '& .section-header__title-wrapper': {
          justifyContent: 'flex-start !important',
          marginBottom: '12px !important',
        },
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'Cormorant-Medium !important',
          fontSize: '48px !important',
          lineHeight: '56px !important',
          letterSpacing: '-0.96px !important',
          fontWeight: 500,
          color: `${palette.text.content} !important`,
          textAlign: 'left !important',
          padding: '0 !important',
          margin: '0 !important',
          '@media(min-width: 600px) and (max-width: 1200px)': {
            fontSize: '40px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.8px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '40px !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 500,
          fontFamily: 'Lato-Regular !important',
          fontSize: '20px !important',
          lineHeight: '26px !important',
          letterSpacing: '-0.4px !important',
          color: `${palette.text.secondary} !important`,
          textAlign: 'left !important',
          margin: '0 !important',
          padding: '0 !important',
          '@media(min-width: 601px) and (max-width: 1200px)': {
            fontSize: '18px !important',
            lineHeight: '24px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '16px !important',
            lineHeight: '22px !important',
          },
        },
      },
      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        borderRadius: '24px !important',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
          maxWidth: '600px !important',
          marginLeft: 'auto',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
        },
      },
      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: `${palette.primary.accent} !important`,
        color: `${palette.text.highlight} !important`,
        fontSize: '14px !important',
        fontWeight: 500,
        fontFamily: 'Lato-Regular !important',
        letterSpacing: '-0.28px !important',
        lineHeight: '20px !important',
        width: '40px !important',
        height: '40px !important',
        minWidth: '40px !important',
        flexShrink: 0,
        margin: '0 !important',
        padding: '0 !important',
      },
      '& .working-steps-main-container': {
        width: '100%',
        display: 'flex !important',
        flexDirection: 'column !important',
      },
      '& .working-steps-container': {
        maxWidth: 'none',
        width: '100%',
        margin: '0 !important',
        marginTop: '0 !important',
        padding: '0 !important',
        display: 'flex !important',
        flexWrap: 'nowrap !important',
        alignItems: 'flex-start !important',
        gap: '24px',
        borderBottom: 'none !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
        '& .step-title': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 600,
          fontFamily: 'Cormorant-Medium !important',
          color: `${palette.text.content} !important`,
          padding: '0 !important',
          margin: '0 0 10px 0 !important',
        },
        '& .step-content': {
          fontSize: '16px !important',
          color: `${palette.text.secondary} !important`,
          lineHeight: '22px !important',
          letterSpacing: '-0.64px !important',
          fontWeight: 400,
          fontFamily: 'Lato-Regular !important',
          margin: '0 !important',
          padding: '0 !important',
        },
      },
      '& .working-steps-main-container > .working-steps-container:not(:last-child)': {
        paddingBottom: '32px !important',
        marginBottom: '0 !important',
        borderBottom: `1px solid ${palette.background.border} !important`,
      },
      '& .working-steps-main-container > .working-steps-container:not(:first-child)': {
        paddingTop: '32px !important',
      },
      '& .working-steps-container:not(:last-child)::after': {
        display: 'none !important',
      },
      '& .step-started-button': {
        marginTop: '40px !important',
        marginLeft: 'auto !important',
        marginRight: 'auto !important',
        display: 'flex !important',
        width: 'fit-content !important',
        padding: '8px 22px !important',
        '@media(max-width: 600px)': {
          marginTop: '32px !important',
        },
        '& .right-icon': {
          display: 'none !important',
        },
      },
    },

    /* Testimonials — Variant 1, matches Figma (16117-48354).
       Image on the left, quote + name + rating on the right, teal eyebrow,
       serif title, and a left-aligned dot pager (active = teal, wide). */
    '& .testimonial-variant-1': {
      '& .testimonialSection': {
        position: 'relative',
      },
      // Title row: teal eyebrow + serif heading, left-aligned.
      '& .testimonial-title-container': {
        marginBottom: '48px !important',
      },
      '& .testimonial-title-container .section-header__overline-wrapper, & .testimonial-title-container .section-header__label-wrapper, & .testimonial-title-container .section-header__overline-wrapper *, & .testimonial-title-container .section-header__label-wrapper *': {
        color: `${palette.text.reviewEyebrow} !important`,
        fontFamily: 'Lato-Regular !important',
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 500,
        textTransform: 'none',
        '@media(max-width: 1280px) and (min-width: 601px)': {
          fontSize: '18px !important',
          lineHeight: '24px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
        },
      },
      '& .testimonial-title-container .section-header__title': {
        fontFamily: 'Cormorant-Medium !important',
        fontSize: '56px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.68px !important',
        fontWeight: 500,
        color: '#152435 !important',
        '@media(max-width: 1280px) and (min-width: 601px)': {
          fontSize: '48px !important',
          lineHeight: '54px !important',
          letterSpacing: '-1.44px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '36px !important',
          lineHeight: '44px !important',
          letterSpacing: '-1.08px !important',
        },
      },
      // Desktop layout: image left, content right.
      '& .testimonial-container': {
        '@media(min-width: 960px)': {
          flexDirection: 'row-reverse !important',
          flexWrap: 'nowrap !important',
          gap: '72px',
          alignItems: 'center !important',
        },
      },
      '& .image-wrapper .image': {
        width: '100% !important',
        maxWidth: '548px !important',
        height: 'auto !important',
        borderRadius: '16px !important',
        objectFit: 'cover !important',
      },
      '& .testimonial-content-wrapper': {
        // position:relative so the nav arrows (below) anchor to this column
        // and can be lifted into the title row without the carousel clipping them.
        position: 'relative',
        '@media(min-width: 960px)': {
          paddingRight: '0 !important',
        },
      },
      // Quote body.
      '& .testimonial-message': {
        color: '#404850 !important',
        fontFamily: 'Lato-Regular !important',
        fontSize: '24px !important',
        lineHeight: '36px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
        '@media(max-width: 600px)': {
          fontSize: '18px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      // Reviewer name (serif) + rating line beneath it.
      '& .testimonial-name': {
        color: '#052335 !important',
        fontFamily: 'Cormorant-Medium !important',
        fontSize: '32px !important',
        lineHeight: '40px !important',
        letterSpacing: '-1.28px !important',
        fontWeight: 500,
        '@media(max-width: 600px)': {
          fontSize: '24px !important',
          lineHeight: '30px !important',
          letterSpacing: '-0.96px !important',
        },
      },
      '& .testimonial-name + .MuiTypography-body2, & .testimonial-location': {
        marginLeft: '0 !important',
        marginTop: '4px !important',
        color: '#717e95 !important',
        fontFamily: 'Lato-Regular !important',
        fontSize: '20px !important',
        lineHeight: '26px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
        '@media(max-width: 600px)': {
          fontSize: '16px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      // Dot pager: left-aligned, inactive grey, active teal + wide.
      '& .react-multi-carousel-dot-list': {
        justifyContent: 'flex-start !important',
        paddingLeft: '0 !important',
      },
      '& .react-multi-carousel-dot button': {
        background: `${palette.background.border} !important`,
        opacity: '1 !important',
        border: 'none !important',
        width: '35px !important',
        height: '4px !important',
        borderRadius: '2px !important',
      },
      '& .react-multi-carousel-dot--active button': {
        background: `${palette.primary.brand} !important`,
        width: '70px !important',
        opacity: '1 !important',
      },
      // Nav arrows — lifted into the title row, top-right (Figma).
      // The carousel list is made position:static so the arrows anchor to the
      // content column (position:relative above) instead of the overflow:hidden
      // list — letting them lift into the title row without being clipped.
      '& .testimonial-content-wrapper .react-multi-carousel-list': {
        position: 'static !important',
      },
      '& .custom-arrow': {
        position: 'absolute !important',
        top: '-140px',
        background: 'transparent !important',
        boxShadow: 'none !important',
        border: 'none !important',
        outline: 'none !important',
        padding: '6px !important',
        borderRadius: '0 !important',
        zIndex: 5,
        '& .testimonial-arrow-icon': { width: '40px', height: '40px', display: 'block' },
        '&:hover': { background: 'transparent !important' },
      },
      '& .custom-arrow.right-arrow': {
        right: '0 !important',
        left: 'auto !important',
        color: `${palette.primary.accent} !important`,
      },
      '& .custom-arrow.left-arrow': {
        right: '56px !important',
        left: 'auto !important',
        color: `${palette.text.arrowInactive} !important`,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: `${palette.primary.main} !important`,
        backgroundColor: `${palette.primary.main} !important`,
        backgroundImage: 'none !important',
      },
      '& .section-header': {
        '& .hero-header-title': {
          fontFamily: 'Cormorant-Medium !important',
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 400,
        },
        '& .hero-header-subtitle': {
          fontFamily: 'Lato-Regular !important',
          fontSize: '18px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: '700 !important',
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .MuiTableCell-head': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.primary.main} !important`,
      },
      '& .footer-bar-text': {
        color: `${palette.text.highlight} !important`,
      },
      '& .MuiButton-containedSecondary, & .view-more-button': {
        backgroundColor: `${palette.primary.main} !important`,
        color: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.text.blueBorder} !important`,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
        fontFamily: 'Lato-Regular !important',
        textTransform: 'uppercase !important',
        '&:hover': {
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.text.primary} !important`,
          opacity: 0.92,
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      position: 'relative',
      background: `${palette.background.dark} !important`,
      borderTop: 'none !important',
      padding: '64px 80px !important',
      '@media(max-width: 1024px)': {
        padding: '48px 40px !important',
      },
      '@media(max-width: 600px)': {
        padding: '48px 20px !important',
      },
      '& .hero-static-bg': {
        display: 'none !important',
      },
      '& .section-alternate.hero-static-section': {
        maxWidth: '1280px !important',
        width: '100%',
        margin: '0 auto !important',
        overflow: 'visible !important',
        padding: '0 !important',
      },
      '& .section-alternate': {
        '& .section-alternate__content': {
          background: 'transparent !important',
          border: 'none !important',
          borderRadius: '0 !important',
          padding: '0 !important',
          width: '100%',
          boxSizing: 'border-box',
        },
      },
      '& .section-header': {
        alignItems: 'flex-start !important',
        marginBottom: '0 !important',
      },
      '& .section-header__title-wrapper': {
        justifyContent: 'flex-start !important',
        marginBottom: '12px !important',
      },
      '& .section-header__title, & .hero-static-title': {
        color: `${palette.text.highlight} !important`,
        fontWeight: 500,
        fontFamily: 'Cormorant-Medium !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.36px !important',
        textAlign: 'left !important',
        padding: '0 !important',
        margin: '0 !important',
      },
      '& .section-header__subtitle, & .hero-static-subtitle': {
        color: `${palette.text.highlight} !important`,
        opacity: 0.8,
        fontWeight: 400,
        fontFamily: 'Lato-Regular !important',
        fontSize: '18px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.54px !important',
        textAlign: 'left !important',
        margin: '0 !important',
        padding: '0 !important',
      },
      '& .hero-static-section-grid': {
        margin: '0 !important',
        width: '100% !important',
        display: 'flex !important',
        flexWrap: 'wrap',
        alignItems: 'center !important',
        justifyContent: 'space-between !important',
        '& > .MuiGrid-item': {
          padding: '0 !important',
        },
      },
      '& .hero-button-wrapper': {
        '& .primary-static-button, & .MuiButton-root': {
          backgroundColor: `${palette.text.highlight} !important`,
          color: `${palette.primary.brand} !important`,
          border: 'none !important',
          borderRadius: '0 !important',
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-1.12px !important',
          fontWeight: 500,
          fontFamily: 'Lato-Regular !important',
          textTransform: 'uppercase !important',
          padding: '12px 20px !important',
          minHeight: 'auto',
          boxShadow: 'none !important',
          '&:hover': {
            backgroundColor: `${palette.text.highlight} !important`,
            color: `${palette.primary.brand} !important`,
            opacity: 0.92,
            boxShadow: 'none !important',
          },
        },
        '@media(min-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'flex-end !important',
          flex: '0 0 auto',
        },
        '@media(max-width: 900px)': {
          display: 'flex !important',
          justifyContent: 'flex-start !important',
          marginTop: '24px !important',
          width: '100%',
        },
      },
      '@media(max-width: 900px)': {
        '& .section-header__title, & .hero-static-title, & .section-header__subtitle, & .hero-static-subtitle':
          {
            textAlign: 'left !important',
          },
      },
    },

    /* Offer Band promo CTA (Figma: centered navy banner) */
    '& .home-offer-band-section': {
      backgroundColor: `${palette.background.offerBand} !important`,
      padding: '80px 80px !important',
      gap: '48px !important',
      '@media(max-width: 1024px)': {
        padding: '64px 40px !important',
      },
      '@media(max-width: 600px)': {
        padding: '48px 20px !important',
        gap: '32px !important',
      },
      '& .offer-band-content': {
        gap: '20px !important',
        maxWidth: '980px',
      },
      '& .offer-band-title': {
        color: `${palette.text.highlight} !important`,
        fontFamily: 'Cormorant-Medium !important',
        fontWeight: '600 !important',
        fontSize: '48px !important',
        lineHeight: '56px !important',
        letterSpacing: '-1.92px !important',
        textAlign: 'center !important',
        '@media(max-width: 1280px)': {
          fontSize: '40px !important',
          lineHeight: '46px !important',
          letterSpacing: '-1.6px !important',
        },
      },
      '& .offer-band-subtitle': {
        color: `${palette.text.highlight} !important`,
        fontFamily: 'Lato-Regular !important',
        fontWeight: '400 !important',
        fontSize: '18px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.54px !important',
        textAlign: 'center !important',
      },
      '& .offer-band-button, & .MuiButton-root': {
        backgroundColor: `${palette.secondary.main} !important`,
        color: `${palette.text.content} !important`,
        border: 'none !important',
        borderRadius: '0 !important',
        fontFamily: 'Lato-Regular !important',
        fontWeight: '500 !important',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-1.12px !important',
        textTransform: 'uppercase !important',
        padding: '12px 16px !important',
        minHeight: 'auto',
        boxShadow: 'none !important',
        '&:hover': {
          backgroundColor: `${palette.secondary.main} !important`,
          color: `${palette.text.content} !important`,
          opacity: 0.92,
          boxShadow: 'none !important',
        },
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'Cormorant-Medium !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Lato-Regular !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: '700 !important',
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .price-value': {
            fontFamily: 'Lato-Regular !important',
          },
          '& .customGetStarted, & .MuiButton-containedPrimary.customGetStarted': {
            backgroundColor: 'transparent !important',
            color: `${palette.primary.main} !important`,
            border: `1px solid ${palette.primary.main} !important`,
            boxShadow: 'none !important',
            '& .MuiButton-label': {
              color: `${palette.primary.main} !important`,
            },
            '&:hover': {
              backgroundColor: `${palette.primary.brand} !important`,
              color: `${palette.text.highlight} !important`,
              opacity: 1,
              boxShadow: 'none !important',
              borderColor: `${palette.primary.brand} !important`,
              '& .MuiButton-label': {
                color: `${palette.text.highlight} !important`,
              },
            },
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
          '& .customBenefitsContainer': {
            '& .bold': {
              fontWeight: 400,
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.content} !important`,
            },
            '& .cptCodes': {
              fontSize: '14px !important',
              lineHeight: '18px !important',
              letterSpacing: '-0.28px !important',
              fontWeight: 400,
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.content} !important`,
            },
          },
          '& .disclaimerContainer': {
            // Cancel MuiGrid spacing's negative side margins so the row and the
            // activation-fee divider stay within the card content.
            marginLeft: '0 !important',
            marginRight: '0 !important',
            width: '100% !important',
            // Flush-left, and drop MuiGrid's item padding so vertical gaps are set
            // explicitly below and match across card variants.
            '& > .MuiGrid-item': {
              paddingLeft: '0 !important',
              paddingTop: '0 !important',
              paddingBottom: '0 !important',
            },
            '& .customUpfrontWrapper': {
              paddingLeft: '0 !important',
              width: '100% !important',
              paddingBottom: '20px !important',
              marginBottom: '20px !important',
              borderBottom: `1px solid ${palette.background.border} !important`,
              color: `${palette.text.tertiary} !important`,
              fontFamily: 'Lato-Regular !important',
              fontStyle: 'normal',
            },
            '& .disclaimerText': {
              fontSize: '12px !important',
              lineHeight: '16px !important',
              letterSpacing: '-0.32px !important',
              fontWeight: 400,
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.tertiary} !important`,
            },
            // Annual Savings: 14px, with a 12px gap before the "* Best For" line.
            // The separator that used to sit under this line was dropped: the
            // plan card now renders its own divider above the whole disclosure
            // block, so keeping this one drew two rules 17px apart.
            '& .annual-savings-disclaimer.bold': {
              display: 'block',
              fontSize: '14px !important',
              lineHeight: '18px !important',
              marginBottom: '12px !important',
            },
            '& .customUpfrontWrapper .bold': {
              fontSize: '12px !important',
              lineHeight: '16px !important',
            },
            '& .bold': {
              fontSize: '16px !important',
              lineHeight: '20px !important',
              letterSpacing: '-0.32px !important',
              fontWeight: 400,
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.tertiary} !important`,
              fontStyle: 'normal',
            },
            '& .annual-savings-label': {
              color: `${palette.primary.brand} !important`,
              marginLeft: '0 !important',
            },
            '& .annual-savings-value, & .annual-savings-disclaimer': {
              color: `${palette.text.tertiary} !important`,
            },
            '& .MuiGrid-item:not(.customUpfrontWrapper) .bold:not(.annual-savings-disclaimer)': {
              color: `${palette.text.tertiary} !important`,
              fontSize: '12px !important',
              lineHeight: '16px !important',
            },
            '& .MuiTypography-body2': {
              fontFamily: 'Lato-Regular !important',
              color: `${palette.text.tertiary} !important`,
            },
          },
        },
      },
    },

    /* FAQ */
    '& .faq-wrapper': {
      '& .faqInnerContainer, & .faq-contact-section': {
        fontFamily: 'Lato-Regular !important',
        '& .MuiTypography-root, & .MuiTab-root, & .faq-link, & .MuiButton-root': {
          fontFamily: 'Lato-Regular !important',
        },
      },
    },
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        margin: '0 auto !important',
        maxWidth: '100% !important',
      },
      '& .header-container': {
        margin: '0 !important',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '0 !important',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.content,
      },
      '& .faq-link': {
        fontSize: '15px !important',
        textTransform: 'none !important',
        fontFamily: 'Lato-Regular !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1, & .accorion_item-title': {
          fontFamily: 'Lato-Regular !important',
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
          color: `${palette.text.content} !important`,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontFamily: 'Lato-Regular !important',
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.background.benefits} !important`,
      borderTop: 'none !important',
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      padding: '96px 80px !important',
      '@media(max-width: 1024px) and (min-width: 900px)': {
        padding: '64px 40px !important',
      },
      '@media(max-width: 900px) and (min-width: 600px)': {
        padding: '64px 40px !important',
      },
      '@media(max-width: 600px) ': {
        padding: '48px 20px !important',
      },
      '& .contact-img-wrapper': {
        width: '56px',
        maxWidth: '56px',
        minHeight: '56px',
        minWidth: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        backgroundColor: 'transparent',
        border: 'none',
        '& img': {
          width: '56px',
          height: '56px',
        },
      },
      '& .contact-card-title': {
        fontFamily: 'Lato-Regular !important',
        fontSize: '36px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.72px !important',
        fontWeight: 400,
        color: `${palette.text.content} !important`,
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.64px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontFamily: 'Lato-Regular !important',
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
        maxWidth: 'unset',
        '@media(max-width: 600px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .provider-contact-details': {
        fontSize: '16px !important',
        fontFamily: 'Lato-Regular !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
        color: palette.text.primary,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
        fontSize: 20,
        lineHeight: '24px !important',
        letterSpacing: '-0.48px !important',
        fontFamily: 'Lato-Regular !important',
        fontWeight: 400,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
        paddingTop: '5px',
        '@media(max-width: 600px)':{
          fontSize: '18px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
        }
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'Cormorant-Medium',
        fontWeight: 400,
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.benefits,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.border,
        color: palette.background.border,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.primary.main,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.primary.main} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.primary.main,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.primary.main  , // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.background.border} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      backgroundColor: palette.background.footer,
      color: `${palette.text.highlight} !important`,
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
      '& p, & span, & .MuiTypography-root': {
        color: `${palette.text.highlight} !important`,
      },
      '& a, & .footer-link, & .copyrights-footer-link, & .MuiButton-root, & .MuiLink-root': {
        color: `${palette.text.highlight} !important`,
      },
      '& .MuiButton-label': {
        color: `${palette.text.highlight} !important`,
      },
    },
  },
};
